import { createFileRoute } from '@tanstack/react-router'

interface IAuditLogSearch {
  page?: number
}

export const Route = createFileRoute('/_authenticated/audit-log')({
  validateSearch: (search: Record<string, unknown>): IAuditLogSearch => ({
    page: Number(search.page) > 1 ? Number(search.page) : undefined,
  }),
})
